import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { Item } from '@app/core/components/listbox/listbox.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({
    selector: 'tt-custact-calc-job-exit',
    templateUrl: './custact-calc-job-exit.component.html',
    styleUrls: ['./custact-calc-job-exit.component.css'],
    standalone: false,
})
export class CustactCalcJobExitComponent implements OnInit {
    @Input()
    public params?: GetCustactCalcJobExitParams;

    public page?: CustactCalcJobExitGet;

    public itemsListFinishedJobs: Item[] = [];

    constructor(
        private datatask: DataTaskService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadPage() {
        if (!!this.params) {
            this.page = (await this.datatask.Post(884, this.params))[0];
        }
    }

    private async loadFinishedJobs() {
        if (!!this.params) {
            this.itemsListFinishedJobs = await this.datatask.Post(882, this.params);
        }
    }

    clickItem (item: any): void {
        item = item?.item ? item.item : item;

        this.datatask.Post(883, {
            labour_no: this.params?.labour_no,
            custact_no: item.item_id
        }).then(() => {
            this.navigator?.go({
                to: item.item_state,
                parms: item.item_parms
            });
        });
    }

    private async init() {
        this.loadPage();
        this.loadFinishedJobs();
    }

    ngOnInit() {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;

            this.init();
        }
    }
}

interface GetCustactCalcJobExitParams {
    labour_no: string;
    custactcalc_custact_no: string;
    function_name: string;
}

interface CustactCalcJobExitGet {
    infotext: string;
}

// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('custactCalcJobExit', {
//         templateUrl: 'views/components/views/custactCalcJobExit/custactCalcJobExit.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'custactCalcJobExitService', function ($stateParams, stateService, custactCalcJobExitService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let labourNo = $stateParams.labour_no;
//             let custactCalcCustactNo = $stateParams.custactcalc_custact_no;
//             let functionName = $stateParams.function_name;

//             vm.model = {
//                 menu: {},
//                 itemsListFinishedJobs: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE CALLS

//             async function loadMenu() {
//                 vm.model.menu = (await custactCalcJobExitService.getMenu({
//                     labour_no: labourNo,
//                     custact_no: custactCalcCustactNo,
//                     function_name: functionName
//                 }))[0];
//             }

//             async function loadFinishedJobs() {
//                 vm.model.itemsListFinishedJobs = await custactCalcJobExitService.listFinishedJobs({
//                     labour_no: labourNo,
//                     custact_no: custactCalcCustactNo,
//                     function_name: functionName
//                 });
//             }

//             // #endregion LOAD PROCEDURE CALLS

//             // #region SEARCH PROCEDURE CALL

//             vm.clickItem = function (item) {
//                 custactCalcJobExitService.setCustactNo({
//                     labour_no: labourNo,
//                     custact_no: item.item_id
//                 }).then(function () {
//                     stateService.go(item.item_state, item.item_parms);
//                 });
//             }

//             // #endregion SEARCH PROCEDURE CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadMenu();
//                 loadFinishedJobs();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
